import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import { selectUIMessages, selectUIProgress } from '../ui/ui.helpers.js';
import { IndexContext } from "./context";

import { About, Contact, Blog, Hero, HowItWorks,
  Banners, UseApps, Journey, AllInclude
} from './components'

import {
  howItWorksSec, journeySec, heroSection, contactSection, useAppsInfo,
  banner, aboutSection, iconsSection, blogItems, blogRightShape
} from './constants/airTourPro'

class CardsScreen extends React.Component {
  constructor(props) {
    super(props);

    const initialState = window.serverData ? window.serverData.initialStateData : {};

    this.state = {
      initialState,
    }
  }

  state = {
    initialState: {}
  };

  render() {
    const { initialState } = this.state;
    const { isLogged, uri, request } = initialState;

    return (
      <IndexContext.Provider value={{
        baseUrl: uri,
        isLogged
      }}>
        <div className="index-wrapper">
          <Hero
            request={request}
            heroSection={heroSection}
            styles={{
              container: 'index-header-atp',
              app: 'app-links-horizontal-atp',
              headerInner: 'index-header-inner-atp',
              form: 'index-header-sing-in-atp',
              formInner: 'index-header-sing-in-form-input-atp'
            }}
          />
          <section className="index-demo container-block" id="how-it-works">
            <HowItWorks
              howItWorksSec={howItWorksSec}
              styles={{ headingBlue: 'index-heading-blue-atp', btn: 'btn-orange-atp' }}
            />
            <Journey
              journeySec={journeySec}
              styles={{ headingBlue: 'index-heading-blue-atp', btn: 'btn-orange-atp' }}
            />
          </section>
          <Banners
            banner={banner}
            styles={{ managementHeading: 'management-heading-blue' }}
          />
          <About
            aboutSection={aboutSection}
            styles={{
              aboutTopRight: 'index-heli-top-right-figure',
              aboutBottomLeft: 'index-heli-bottom-left-figure',
              aboutTopLeft: 'index-heli-top-left-figure'
            }}
          />
          <AllInclude
            iconsSection={iconsSection}
            styles={{
              allIncludeIcons: 'atp-all-include-icon-wrap',
              iconSprite: 'icon-sprite-color'
            }}
          />
          <UseApps
            useAppsInfo={useAppsInfo}
            styles={{ useAppsSection: 'atp-use-apps' }}
          />
          <Blog
            blogItems={blogItems}
            blogRightShape={blogRightShape}
            styles={{
              BlogShape: 'blog-heli-top-right-figure',
              blogSvg: 'blog-shape-svg',
              twitterFigure: 'tw-right-figure'
            }}
          />
          <Contact
            contactSection={contactSection}
            styles={{
              heliContact: 'atp-heli-contact',
              navFooter: 'atp-nav-footer',
              navFooterItem: 'atp-nav-footer-item'
            }}
          />
        </div>
      </IndexContext.Provider>
    );
  }
}

const progressSelector = selectUIProgress();
const messagesSelector = selectUIMessages();

const mapStateToProps = state => ({
  URL: state.URL,
  progress: progressSelector(state),
  messages: messagesSelector(state),
  accessgroups: state.accessgroups
});

export default connect(
  mapStateToProps,
  {...formActions},
  mergeActionsToProps
)(CardsScreen);
